import { css } from 'styled-components';
import { FontLineHeightNormal } from 'autogen/design-tokens/global/tokens';

const LinkText = css<{ $strong?: boolean }>`
    font-family: ${({ theme }) => theme.TypographyFamilyPrimary};
    font-weight: ${({ $strong, theme }) => ($strong ? theme.TypographyLinkWeightStrong : theme.TypographyLinkWeightDefault)};
    line-height: ${FontLineHeightNormal};
    text-decoration: underline;
`;

export default LinkText;
